import styled, { css } from 'styled-components';

interface InputWrapperProps {
  focused?: boolean;
}

export const InputWrapper = styled.div<InputWrapperProps>`
  width: 100%;
  height: 52px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.bg500};
  background-color: ${({ theme }) => theme.palette.bg800};
  position: relative;
  overflow: hidden;
  transition: background-color 0.1s;

  /* ${({ focused }) =>
    focused &&
    css`
      background-color: ${({ theme }) => theme.palette.grayscale200};
    `} */
`;

export const Input = styled.input`
  width: 100%;
  height: 52px;
  padding-left: 16px;
  background: none;
  outline: 0;
  border-width: 0;
  color: ${({ theme }) => theme.palette.grayscale300};

  &::placeholder {
    color: ${({ theme }) => theme.palette.grayscale600};
  }

  /* &:focus {
    background-color: ${({ theme }) => theme.palette.grayscale200};
    color: ${({ theme }) => theme.palette.grayscale800};
  } */
`;

export const Button = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
`;
